import {observable, action, runInAction} from 'mobx'
import {json} from '../../../utils/ajax'
import {setStore, handleSeerchAndPage, ValueObjToObj, handleSearchAndPage} from "../../../utils/Utils";
import {message} from "antd/lib/index";
import moment from "moment";

class serviceStationStore {
    @observable list
    @observable page
    @observable loading
    @observable searchFields//主页面搜索框
    @observable modal  //modal
    @observable addParams
    @observable districtList
    @observable flag
    @observable addUserModal
    @observable authorizeModal
    @observable brandModal
    @observable carList
    @observable resList
    @observable labelList
    @observable contrastRes //对比容器
    @observable serviceStationCarSystem
    @observable sendSpendData
    @observable optionList
    @observable defList
    @observable userModal
    @observable concatParam
    @observable userList
    @observable searchUser
    @observable userPage
    @observable languageList
    @observable addUserData
    @observable addStationModal
    @observable addNextStationParms
    @observable item
    @observable nextStationMagnagerModal //前台弹窗
    @observable receptionTableData
    @observable editInfo
    @observable state
    @observable resStatus
    @observable checkData
    @observable checkFlag
    @observable ReceptionAuthorizeModal
    @observable contrastReceptionRes
    @observable boo
    @observable searchUserModal
    @observable resList1
    @observable carList1
    @observable contrastRes1
    @observable brandAllEpc
    @observable manualAllBrands
    @observable brandEpc
    @observable manualBrands
    @observable searchField //表单搜索值
    @observable oneModal //一键授权
    @observable oneBrandEpc //一键授权
    @observable oneManualBrands //一键授权

    constructor() {
        this.ReceptionAuthorizeModal = 'hide'
        this.modal = 'hide'
        this.userModal = 'hide'
        this.list = []
        this.page = {
            current: 0,
            total: 1
        }
        this.searchUserModal = 'hide'
        this.boo = false
        this.contrastReceptionRes = []
        this.checkFlag = false
        this.checkData = ''
        this.resStatus = {}
        this.editInfo = {}
        this.state = ''
        this.nextStationMagnagerModal = 'hide'
        this.addStationModal = 'hide'
        this.userPage = {
            current: 0,
            total: 1
        }
        this.languageList = []
        this.userList = []
        this.concatParam = ''
        this.defList = []
        this.sendSpendData = ''
        this.serviceStationCarSystem = {
            id: '',
            serviceCode: '',
            carCode: ''
        }
        this.searchUser = {
            serviceCode: '',
            userNameAndLoginName: '',
        }
        this.optionList = []
        this.contrastRes = []
        this.contrastRes1 = []
        this.brandAllEpc=[]
        this.manualAllBrands = []
        this.brandEpc = []
        this.manualBrands = []
        this.labelList = []
        this.resList = []
        this.carList = []
        this.resList1 = []
        this.carList1 = []
        this.authorizeModal = 'hide'
        this.brandModal = 'hide'
        this.addUserModal = 'hide'
        this.flag = false
        this.districtList = []
        this.pagination = {
            current: 0,
            total: 1
        }
        this.searchFields = {
            serviceNameOrCode: ''
        }
        this.item = ''
        this.addParams = {
            serviceName: '',
            serviceCode: '',
            isMark: '',
            district: '',
            shortName: '',
            addressPath: '',
            defaultLanguage: ''
        }
        this.addUserData = {
            serviceCode: '',
            loginName: '',
            userName: '',
            email: '',
            phone: '',
            companyId: '',
            passWord: '',
        }
        this.addNextStationParms = {
            serviceName: '',
            serviceCode: '',
            isMark: '',
            district: '',
            shortName: '',
            addressPath: '',
            defaultLanguage: '',
            pid: '',
            level: '',
            state: ''
        }
        this.receptionTableData = []
        this.searchField = {
            defaultLanguage: '',
            serviceNameOrCode: ''
        }
        this.oneModal=false
        this.oneBrandEpc=[]
        this.oneManualBrands=[]
    }

    @action
    addUserFiledChange = (changedFields) => {
        runInAction(() => {
            this.addUserData = {
                serviceCode: changedFields.serviceCode ? changedFields.serviceCode.value : this.addUserData.serviceCode,
                userName: changedFields.userName ? changedFields.userName.value : this.addUserData.userName,
                loginName: changedFields.loginName ? changedFields.loginName.value : this.addUserData.loginName,
                email: changedFields.email ? changedFields.email.value : this.addUserData.email,
                phone: changedFields.phone ? changedFields.phone.value : this.addUserData.phone,
                passWord: changedFields.passWord ? changedFields.passWord.value : this.addUserData.passWord
            }
        })
    }
    @action
    searchFieldChange = (changedFields) => {
        runInAction(() => {
            this.addParams = {
                serviceName: changedFields.serviceName ? changedFields.serviceName.value : this.addParams.serviceName,
                serviceCode: changedFields.serviceCode ? changedFields.serviceCode.value : this.addParams.serviceCode,
                isMark: changedFields.isMark ? changedFields.isMark.value : this.addParams.isMark,
                district: changedFields.district ? changedFields.district.value : this.addParams.district,
                shortName: changedFields.shortName ? changedFields.shortName.value : this.addParams.shortName,
                addressPath: changedFields.addressPath ? changedFields.addressPath.value : this.addParams.addressPath,
                defaultLanguage: changedFields.defaultLanguage ? changedFields.defaultLanguage.value : this.addParams.defaultLanguage
            }
        })
    }

    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    @action
    initPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchField = {
            ...this.searchField,
            defaultLanguage: this.searchField.defaultLanguage ? this.searchField.defaultLanguage:'',
            serviceNameOrCode:this.searchField.serviceNameOrCode ? this.searchField.serviceNameOrCode :'',
        };
        // let searchResult = handleSearchAndPage(page, this.pagination, searchField)
        let search = handleSeerchAndPage(page, this.pagination, searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station:search`, search)
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }
    /**
     * list搜索框
     * @param value
     * @param page
     * @returns {Promise<void>}
     */
    @action
    inquire = async ( page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchField = {
            ...this.searchField,
            defaultLanguage: this.searchField.defaultLanguage ? this.searchField.defaultLanguage:'',
            serviceNameOrCode:this.searchField.serviceNameOrCode ? this.searchField.serviceNameOrCode :'',
        };
        let search = handleSeerchAndPage(page, this.pagination, searchField)
        // const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/station:search`, search)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station:search`, search)
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    // @action
    // saveSearch = async (value) => {
    //     runInAction(() => {
    //         this.searchFields.serviceNameOrCode = value
    //     })
    // }
    //
    // @action
    // saveLan = async (value) => {
    //     runInAction(() => {
    //         this.searchFields.defaultLanguage = value
    //     })
    // }

    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }


    /***重置**/
    @action
    handleReset=()=>{
        this.searchField = {
            serviceNameOrCode: '',
            defaultLanguage: '',
        }
        this.initPage()
    }

    @action
    showAddModal = (value) => {
        runInAction(() => {
            this.loading = true
            if (value === true) {
                this.addParams = {
                    serviceName: '',
                    serviceCode: '',
                    isMark: '',
                    district: '',
                    shortName: '',
                    addressPath: '',
                    defaultLanguage: ''
                }
                this.defList = []
                this.flag = false
            }
        })
        this.modal = 'show'
        runInAction(() => {
            this.loading = false
        })
    }
    @action
    showUpdateModal = (value) => {
        let address = this.addParams.addressPath !== null ? this.addParams.addressPath.split("/").slice(0, this.addParams.addressPath.split("/").length - 1) : ''
        runInAction(() => {
            this.loading = true
            this.flag = true
            this.addParams = value
            this.spendData(this.addParams.district)
            this.modal = 'show'
            this.defList = Array.isArray(address) ? address : []
            this.loading = false
        })
    }
    @action
    AddModelHide = () => {
        runInAction(() => {
            this.loading = true
            this.addParams = {
                serviceName: '',
                serviceCode: '',
                isMark: '',
                district: '',
                shortName: '',
                addressPath: '',
                defaultLanguage: ''
            }
            this.modal = 'hide'
            this.loading = false
        })
    }
    /**
     * 字典接口待定
     * @returns {Promise<void>}
     */
    @action
    addCommit = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (this.flag === false) {
            let args ={...this.addParams,
                isMark: 0 ,
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station/insert/one`, args)
        } else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station/update/one`, this.addParams)
        }
        runInAction(() => {
            this.modal = 'hide'
            this.loading = false
        })
        this.initPage(this.page)
    }
    /**
     * 省市区 拼接参数
     */
    @action
    bindAddressPathData = (value) => {
        runInAction(() => {
            this.loading = true
            this.sendSpendData = value.join("/") + "/"
            this.addParams.addressPath = this.sendSpendData
            this.defList = this.addParams.addressPath.split("/").slice(0, this.addParams.addressPath.split("/").length - 1)
            this.loading = false
        })
    }
    /**
     * 查询所有大区   字典表接口 待定-----------
     */
    @action
    toGetDistrictList = async () => {
        runInAction(() => {
            this.loading = true
        })
        const name = "国家和地区/"
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/dictionary/getOneRoot`, {'name': name})
        runInAction(() => {
            this.districtList = res.children || []
            this.loading = false
        })
    }
    @action
    toGetLanguage = async () => {
        runInAction(() => {
            this.loading = true
        })
        const name = "语言/"
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/dictionary/getOneRoot`, {'name': name})
        runInAction(() => {
            this.languageList = res.children || []
            this.loading = false
        })
    }
    @action
    deleteOne = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station/delete/one/${value.id}`)
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/userOperationRecord/serviceStationdelById/id/${value.id}`)
        runInAction(() => {
            this.loading = false
        })
        this.initPage(this.page)
    }


    @action
    showUserAddModal = (value) => {
        runInAction(() => {
            this.loading = true
            this.addUserData = {
                serviceCode: '',
                loginName: '',
                userName: '',
                email: '',
                phone: '',
                companyId: '',
                passWord: '',
            }
            this.boo = false
            this.addParams = value
            this.addUserModal = 'show'
            this.loading = false
        })
    }
    /**
     * 新增下级服务站
     * @param value  倒换值
     */
    @action
    showAddStationModal = (value) => {
        runInAction(() => {
            this.loading = true
            this.addParams = {
                serviceName: '',
                serviceCode: '',
                isMark: '',
                district: '',
                shortName: '',
                addressPath: '',
                defaultLanguage: ''
            }
            this.defList = []
            this.addStationModal = 'show'
            this.item = value
            this.loading = false
        })
    }
    @action
    closeUserAddModal = () => {
        runInAction(() => {
            this.loading = true
            this.addUserModal = 'hide'
            this.loading = false
        })
    }
    @action
    authorizeModalShow = (value) => {
        runInAction(() => {
            this.brandEpc=[]
            this.manualBrands=[]
            this.contrastReceptionRes=[]
            this.contrastRes1=[]
            this.contrastRes=[]
            this.carList1=[]
            this.carList=[]
            this.loading = true
            this.authorizeModal = 'show'
            this.addParams = value
            this.getAllCariese()
            if(value.district !== "海外一键授权" ){
                this.getManyCariese(value)
            }
            this.loading = false
        })
    }
    @action
    brandModalShow = (value) => {
        runInAction(() => {
            this.loading = true
            this.brandModal = 'show'
            this.addParams = value
            this.getBrandALL();
            this.getManyCariese(value)
            this.loading = false
        })
    }

    @action
    oneModalShow = (value) => {
        runInAction(() => {
            this.loading = true
            this.oneModal = 'show'
            this.getBrandALL();
            // this.getManyCariese()
            this.loading = false
        })
    }

    @action
    authorizeModalHide = () => {
        runInAction(() => {
            this.loading = true
            this.authorizeModal = 'hide'
            this.loading = false
        })
    }

    @action
    brandModalHide = () => {
        runInAction(() => {
            this.loading = true
            this.brandModal = 'hide'
            this.loading = false
        })
    }

    @action
    oneModalHide = () => {
        runInAction(() => {
            this.loading = true
            this.oneModal = 'hide'
            this.loading = false
        })
    }
    /**
     * 请求车系
     * @returns {Promise<void>}
     */
    @action
    getAllCariese = async () => {
        runInAction(() => {
            this.loading = true
        })
        this.carList = []
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/manualSeries`)
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/object/carsystem`)
        runInAction(() => {
            this.resList = Array.isArray(res) ? res : []
            this.resList.forEach((item, index, array) => {
                this.carList.push(item)
            })
            this.resList1 = Array.isArray(res1) ? res1 : []
            this.resList1.forEach((item, index, array) => {
                this.carList1.push(item)
            })
            this.loading = false
        })
    }

    @action
    getManyCariese = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/carcode/get/${value.serviceCode}`)
        runInAction(() => {
            this.contrastRes = res.carCode ? res.carCode.split("/").slice(1, res.carCode.split("/").length - 1) : []
            this.contrastRes1 = res.epcCarCode ? res.epcCarCode.split("/").slice(1, res.epcCarCode.split("/").length - 1) : []
            this.brandEpc = res.epcBrand ? res.epcBrand.split("/").slice(1, res.epcBrand.split("/").length - 1) : []
            this.manualBrands = res.manualBrand ? res.manualBrand.split("/").slice(1, res.manualBrand.split("/").length - 1) : []
            this.contrastReceptionRes = this.contrastRes
            this.loading = false
        })
    }

    @action
    getBrandALL= async (value) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/epcAllBrands`)
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/manualAllBrands`)
        runInAction(() => {
            this.brandAllEpc =res
            this.manualAllBrands=res1
        })
    }

    @action
    bindDataByLabel = (list) => {
        runInAction(() => {
            this.loading = true
            this.contrastRes = list
            this.loading = false
        })
    }
    @action
    bindDataByLabel1 = (list) => {
        runInAction(() => {
            this.loading = true
            this.contrastRes1 = list
            this.loading = false
        })
    }

    @action
    bindBrandByLabel = (list) => {
        runInAction(() => {
            this.loading = true
            this.contrastRes = list
            this.loading = false
        })
    }

    @action
    bindManualAllBrands = (list) => {
        runInAction(() => {
            this.loading = true
            this.manualBrands = list
            this.loading = false
        })
    }

    @action
    bindOneManualAllBrands = (list) => {
        runInAction(() => {
            this.loading = true
            this.oneManualBrands = list
            this.loading = false
        })
    }


    @action
    bindBrandByLabel1 = (list) => {
        runInAction(() => {
            this.loading = true
            this.contrastRes1 = list
            this.loading = false
        })
    }

    @action
    bindBrandAllEpc = (list) => {
        runInAction(() => {
            this.loading = true
            this.brandEpc = list
            this.loading = false
        })
    }

    @action
    bindOneBrandAllEpc = (list) => {
        runInAction(() => {
            this.loading = true
            this.oneBrandEpc = list
            this.loading = false
        })
    }

    @action
    AuthorizeSubmit = async () => {
        runInAction(() => {
            this.loading = true
        })
        this.serviceStationCarSystem.serviceCode = this.addParams.serviceCode
        this.serviceStationCarSystem.id = this.addParams.id
        this.serviceStationCarSystem.carCode = "/".concat(this.contrastRes.join("/")).concat("/")
        this.serviceStationCarSystem.epcCarCode = "/".concat(this.contrastRes1.join("/")).concat("/")
        this.serviceStationCarSystem.path = this.addParams.path
        this.serviceStationCarSystem.pid = this.addParams.pid


        this.addParams.district=== "海外" ?
            await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/overseasAuthorizedCarSeries`, this.serviceStationCarSystem)
        :
        await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/update`, this.serviceStationCarSystem)
        runInAction(() => {
            this.authorizeModal = 'hide'
            this.loading = false
        })
        this.initPage(this.page)
    }


    @action
    overseasAuthorizedCar = async () => {
        runInAction(() => {
            this.loading = true
        })
        const obj = {epcCarCode:"/".concat(this.contrastRes1.join("/")).concat("/")}
        await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/overseasOneClickAuthorizedCarSeries`, obj)
        runInAction(() => {
            this.authorizeModal = 'hide'
            this.loading = false
        })
        this.initPage(this.page)
    }

    @action
    brandAuthorizeSubmit = async () => {
        runInAction(() => {
            this.loading = true
        })
        this.serviceStationCarSystem.serviceCode = this.addParams.serviceCode
        this.serviceStationCarSystem.id = this.addParams.id
        this.serviceStationCarSystem.epcBrand  = "/".concat(this.brandEpc.join("/")).concat("/")
        // this.serviceStationCarSystem.manualBrand = "/".concat(this.manualBrands.join("/")).concat("/")
        this.serviceStationCarSystem.path = this.addParams.path
        this.serviceStationCarSystem.pid = this.addParams.pid
        await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/brandAuthorization`, this.serviceStationCarSystem)
        runInAction(() => {
            this.brandModal = 'hide'
            this.loading = false
        })
        this.initPage(this.page)
    }

    @action
    oneAuthorizeSubmit = async () => {
        runInAction(() => {
            this.loading = true
        })
        let obj ={
            serviceCode : '',
            id : '',
            path  : '',
            pid  : '',
            epcBrand:  "/".concat(this.oneBrandEpc.join("/")).concat("/"),
            manualBrand: "/".concat(this.oneManualBrands.join("/")).concat("/")
        }
        await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/domesticOneClickAuthorizedBrand`, obj)
        runInAction(() => {
            this.oneModal = 'hide'
            this.loading = false
        })
        this.initPage(this.page)
    }


    @action
    spendData = async (value) => {
        runInAction(() => {
            this.loading = true
            this.addParams.district = value
        })
        const name = `国家和地区/${value}/`
        // const res = await  json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/dictionary/getOneRoot`, {'name': name})
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/dictionary/getOneRoot`, {'name': name})
        runInAction(() => {
            this.optionList = res.children
            this.loading = false
        })
    }
    /**
     * 查询值倒换
     * @param value
     */
    @action
    userModalShow = (value) => {
        runInAction(() => {
            this.loading = true
            this.userModal = 'show'
            this.concatParam = value.serviceCode
            this.searchUser.serviceCode = this.concatParam
            this.initUser(this.searchUser)
            this.loading = false
        })
    }

    @action
    userModalClose = () => {
        runInAction(() => {
            this.loading = true
            this.userModal = 'hide'
            this.searchUser = {
                serviceCode: '',
                userName: '',
            }
            this.loading = false
        })
    }
    @action
    initUser = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        let search = handleSeerchAndPage(this.userPage, this.pagination, this.searchUser)
        search.size = 100
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/viewUsers/${this.searchUser.serviceCode}`)
        runInAction(() => {
            this.userList = res || []
            this.loading = false
        })
    }
    @action
    findUser = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        this.searchUser.userNameAndLoginName = value
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/viewUsers/${this.searchUser.serviceCode}`)
        runInAction(() => {
            this.userList = res || []
            this.loading = false
        })
    }

    @action
    deleteUser = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationUser/deleteByLoginName/${value}`)
        runInAction(() => {
            this.loading = false
        })
    }

    @action
    DeleteByLoginNameAndServiceCode = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationUser/deleteByLoginName/${value.loginName}`)
        runInAction(() => {
            this.loading = false
        })
        this.findUser(this.searchUser.userName)
    }

    /** 添加用户 **/
    @action
    addUser = async (values) => {
        runInAction(() => {
            this.loading = true
        })
        this.addUserData = values
        // await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/station/query/${this.addUserData.loginName}/${this.addParams.serviceCode}`)
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationUser/station/user/insert`, this.addUserData)
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/userOperationRecord/addUserOperationRecord/${this.addUserData.loginName}`)
        this.closeUserAddModal()
        runInAction(() => {
            this.loading = false
        })
    }

    @action
    loginNameCheck = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationUser/station/check/${value}/${this.addParams.serviceCode}`)
        runInAction(() => {
            if (res.loginName) {
                this.addUserData.loginName = res.loginName
                this.addUserData.passWord = res.password
                this.addUserData.userName = res.name
                this.addUserData.email = res.email
                this.addUserData.phone = res.phone
                this.boo = true
                // message.warning("该用户已存在")
            } else {
                this.boo = false
                this.addUserData = {
                    loginName: this.addUserData.loginName,
                    passWord: '',
                    userName: '',
                    email: '',
                    phone: ''
                }
            }
            this.loading = false
        })
    }

    /** 查询服务站是否存在 **/
    @action
    checkCodeByStation = async (value) => {
        runInAction(() => {
            this.loading = true
            this.checkData = value
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/station/get/check/${this.checkData}`)
        runInAction(() => {
            if (res.serviceCode === this.checkData) {
                message.error("你输入的服务站代码已存在")
                this.checkFlag = true
            }
            this.loading = false
        })
    }

    /**
     * 新增下级服务站（关闭modal）
     */
    @action
    closeNextStationModal = () => {
        runInAction(() => {
            this.addParams = {
                serviceName: '',
                serviceCode: '',
                isMark: '',
                district: '',
                shortName: '',
                addressPath: '',
                defaultLanguage: ''
            }
            this.defList = []
            this.loading = true
            this.addStationModal = 'hide'
            this.loading = false
        })
    }
    @action
    addNextStationCommit = async () => {
        runInAction(() => {
            this.loading = true
        })
        this.addNextStationParms.serviceCode = this.addParams.serviceCode
        this.addNextStationParms.serviceName = this.addParams.serviceName
        this.addNextStationParms.shortName = this.addParams.shortName
        this.addNextStationParms.defaultLanguage = this.addParams.defaultLanguage
        this.addNextStationParms.isMark = this.addParams.isMark
        this.addNextStationParms.district = this.addParams.district
        this.addNextStationParms.addressPath = this.addParams.addressPath
        this.addNextStationParms.state = this.item.state
        this.addNextStationParms.pid = this.item.id
        this.addNextStationParms.level = this.item.level + 1
        this.addNextStationParms.path = this.item.path + this.addParams.serviceCode.concat("/")
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/station/insert/next`, this.addNextStationParms)
        runInAction(() => {
            this.closeNextStationModal()
            this.loading = false
        })
        this.initPage(this.page)
    }

    /**********************************************前台下级服务站管理begin************************************************/

    /***
     * 用户登录后，请求该用户所属服务站及子服务站
     * @param value
     */
    @action
    showNextStationMagnagerModal = (value) => {
        runInAction(() => {
            this.loading = true
            this.nextStationMagnagerModal = 'show'
            this.loading = false
        })
        this.initData(value)
    }
    @action
    closeMagnagerModal = () => {
        this.nextStationMagnagerModal = 'hide'
    }
    /**
     * 只有是一级服务站所属用户 才能操作子集服务站，子集服务站所属用户没有操作权限
     * @param value
     * @returns {Promise<void>}
     */
    @action
    initData = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/station/get/station/${value}`)
        runInAction(() => {
            this.receptionTableData = res || []
            this.resStatus = this.receptionTableData[0]
            this.loading = false
        })
    }

    /**
     * 倒换item值 item 选中行对象   e 菜单key
     * @param item
     */
    @action
    info = (item, e) => {
        runInAction(() => {
            this.editInfo = item
            this.state = e
        })
    }
    @action
    ReceptionAuthorizeModalShow = (value) => {
        runInAction(() => {
            this.loading = true
            this.ReceptionAuthorizeModal = 'show'
            this.addParams = value
            this.getManyCariese(value)
            this.loading = false
        })
    }
    @action
    ReceptionAuthorizeModalHide = () => {
        runInAction(() => {
            this.loading = true
            this.ReceptionAuthorizeModal = 'hide'
            this.loading = false
        })
    }
    @action
    ReceptionAuthorizeSubmit = async () => {
        runInAction(() => {
            this.loading = true
        })
        this.serviceStationCarSystem.serviceCode = this.addParams.serviceCode
        this.serviceStationCarSystem.id = this.addParams.id
        this.serviceStationCarSystem.carCode = "/".concat(this.contrastReceptionRes.join("/")).concat("/")
        this.serviceStationCarSystem.epcCarCode = "/".concat(this.contrastReceptionRes1.join("/")).concat("/")
        await json.put(` ${process.env.REACT_APP_API_URL}/onestep/base/station/carcode/update`, this.serviceStationCarSystem)
        runInAction(() => {
            this.authorizeModal = 'hide'
            this.loading = false
        })
        this.ReceptionAuthorizeModalHide()
    }

    @action
    bindReceptionDataByLabel = (list) => {
        runInAction(() => {
            this.loading = true
            this.contrastReceptionRes = list
            this.loading = false
        })
    }

    /*******************************************前台下级服务站管理end***********************************************/

    /** 查询值倒换 **/
    @action
    searchUserModalShow = () => {
        runInAction(() => {
            this.loading = true
            this.searchUserModal = 'show'
            this.initUser(this.searchUser)
            this.loading = false
        })
    }

    @action
    searchUserModalClose = () => {
        runInAction(() => {
            this.loading = true
            this.searchUserModal = 'hide'
            this.searchUser = {
                serviceCode: '',
                userName: '',
            }
            this.userList = []
            this.loading = false
        })
    }

    @action
    empowerData = async () => {
        this.loading = true
        // const res = await json.get(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/oneClickCarAuthorization`)
        const res = await json.get(` ${process.env.REACT_APP_API_URL}/onestep/base/customerService/stationCarSystem/domesticOneClickAuthorizedBrand`)
        runInAction(() => {
            if (res.status) {
                message.success(`一键授权成功！`)
            }
            this.loading = false
        })
    }
}

export default new serviceStationStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/ServiceStation/store.js